/* RYTM how-to-use carousel. Vanilla JS, no dependencies, safe for multiple instances per page. */
(function () {
  'use strict';

  function initInstance(root) {
    if (root.dataset.rytmHowtoInit === 'true') return;
    root.dataset.rytmHowtoInit = 'true';

    var track = root.querySelector('[data-rytm-howto-track]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-rytm-howto-step]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rytm-howto-dot]'));
    if (!track || steps.length < 2 || dots.length < 2) return;

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.dataset.index, 10) || 0;
        var target = steps[index];
        if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var index = steps.indexOf(entry.target);
            if (index > -1) setActive(index);
          });
        },
        { root: track, threshold: 0.6 }
      );
      steps.forEach(function (step) {
        observer.observe(step);
      });
    }

    setActive(0);
  }

  function initAll(context) {
    var scope = context || document;
    var instances = [];

    if (scope.matches && scope.matches('[data-rytm-howto]')) {
      instances.push(scope);
    }
    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-rytm-howto]'), function (el) {
        instances.push(el);
      });
    }

    instances.forEach(initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();